import { CONTACTS_ENABLED, AI_AVATARS_ENABLED, AI_VOICES_ENABLED, AI_STUDIO_BLOCKED_PLANS, AI_CREATIVE_STUDIO_ENABLED } from 'components/ui/utils/constant'
import {
    NAV_ITEM_TYPE_COLLAPSE,
    NAV_ITEM_TYPE_ITEM,
    NAV_ITEM_TYPE_TITLE,
} from 'constants/navigation.constant'
import { tools } from 'views/post_playground'
import { createContext, useContext, useMemo } from 'react'
import { useWhitelabel } from 'contexts/WhitelabelThemeContext'
import { AppSumoContext } from 'contexts/AppSumoContext'
import { CompanyContext } from 'contexts/CompanyContext'
import { SessionContext } from 'contexts/SessionContext'
import { filterNavigationByVisibility } from './utils'

const createNavigationConfig = (hasWhiteLabelAddOn = false, isWhitelabel = false, isSumoling = false, isSystemAdmin = false) => [
    // Dashboard Section
    {
        key: 'dashboard.section',
        path: '',
        title: 'Dashboard',
        translateKey: 'nav.dashboard',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'home',
                path: '/home',
                title: 'Home',
                translateKey: 'nav.home',
                icon: 'home',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
        ],
    },

    // Content & Scheduling Section
    {
        key: 'content.section',
        path: '',
        title: 'Content & Scheduling',
        translateKey: 'nav.contentScheduling',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'calendar',
                path: '/calendar',
                title: 'Calendar',
                translateKey: 'nav.calendar',
                icon: 'calendar',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'posts_generator',
                path: '',
                title: 'Post Generator',
                translateKey: 'nav.postGenerator',
                icon: 'posts_generator',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [],
                subMenu: tools.filter(e => !e?.hidden).map((tool) => {
                    return {
                        key: tool.id,
                        path: `/post-generator/${tool.id}`,
                        title: tool.short_title,
                        icon: tool.icon,
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [],
                        subMenu: [],
                        needUpgrade: tool?.needUpgrade || [],
                    }
                }),
            },
            {
                key: 'posts',
                path: '/posts',
                title: 'My Posts',
                translateKey: 'nav.posts',
                icon: 'posts',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'media',
                path: '/media',
                title: 'Media Library',
                translateKey: 'nav.my_media',
                icon: 'my_media',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
        ],
    },

    // AI Images Section
    {
        key: 'ai_images.section',
        path: '',
        title: 'AI Images',
        translateKey: 'nav.ai_images_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            ...(AI_CREATIVE_STUDIO_ENABLED ? [
                {
                    key: 'ai-creative-studio',
                    path: '/ai-creative-studio',
                    title: 'Creative Studio',
                    translateKey: 'nav.creative_studio',
                    icon: 'creative_studio',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                    new: true,
                },
            ] : []),
            {
                key: 'ai-image',
                path: '/ai-image',
                title: 'AI Images',
                translateKey: 'nav.ai_images',
                icon: 'ai_images',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'ai-image-create',
                path: '/ai-image-create',
                title: 'Create AI Image',
                translateKey: 'nav.create_ai_image',
                icon: 'ai_images',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            ...(!isSumoling ? [
                {
                    key: 'ai-image-editor',
                    path: '/ai-image-editor',
                    title: 'AI Image Editor',
                    translateKey: 'nav.ai_image_editor',
                    icon: 'ai_image_editor',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                }
            ] : []),
        ],
    },

    // AI Videos Section
    {
        key: 'ai_videos.section',
        path: '',
        title: 'AI Videos',
        translateKey: 'nav.ai_videos_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'ai-videos',
                path: '/ai-videos',
                title: 'AI Videos',
                translateKey: 'nav.ai_videos',
                icon: 'video',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'ai-videos-create',
                path: '/ai-videos-create',
                title: 'Create AI Video',
                translateKey: 'nav.create_ai_video',
                icon: 'video',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
        ],
    },

    // AI Avatars Section
    ...(AI_AVATARS_ENABLED ? [{
        key: 'ai_avatars.section',
        path: '',
        title: 'AI Avatars',
        translateKey: 'nav.ai_avatars_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'ai-avatars',
                path: '/ai-avatars',
                title: 'My AI Avatars',
                translateKey: 'nav.ai_avatars',
                icon: 'avatar',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
            {
                key: 'ai-avatars-create',
                path: '/ai-avatars-create',
                title: 'Create Avatar Video',
                translateKey: 'nav.ai_avatars_creator',
                icon: 'avatar_creator',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
            {
                key: 'ai-avatar-images',
                path: '/ai-avatar-images',
                title: 'Create Avatar Images',
                translateKey: 'nav.ai_avatar_images',
                icon: 'ai_avatar_images',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
        ],
    }] : []),

    // AI Viral Shorts Section
    ...(AI_AVATARS_ENABLED ? [{
        key: 'viral_shorts.section',
        path: '',
        title: 'AI Viral Shorts',
        translateKey: 'nav.viral_shorts_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'viral-shorts',
                path: '/viral-shorts',
                title: 'AI Viral Shorts',
                translateKey: 'nav.viral_shorts',
                icon: 'viral_shorts',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
            {
                key: 'viral-short-creator',
                path: '/viral-short-creator',
                title: 'Viral Short Creator',
                translateKey: 'nav.viral_short_creator',
                icon: 'video',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
        ],
    }] : []),

    // Engagement & Automation Section
    {
        key: 'engagement.section',
        path: '',
        title: 'Engagement & Automation',
        translateKey: 'nav.engagementAutomation',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'social_hub',
                path: '',
                title: 'Social Hub',
                translateKey: 'nav.social_hub',
                icon: 'social_hub',
                type: NAV_ITEM_TYPE_COLLAPSE,
                add: "unread_all",
                authority: [],
                needUpgrade: [],
                subMenu: [
                    {
                        key: 'messages',
                        path: '/hub/messages',
                        title: 'Messages',
                        translateKey: 'nav.messages',
                        icon: 'messages',
                        type: NAV_ITEM_TYPE_ITEM,
                        add: "unread_messages",
                        authority: [],
                        subMenu: [],
                        needUpgrade: [],
                    },
                    {
                        key: 'comments',
                        path: '/hub/comments',
                        title: 'Comments',
                        translateKey: 'nav.comments',
                        icon: 'comments',
                        type: NAV_ITEM_TYPE_ITEM,
                        add: "unread_comments",
                        authority: [],
                        subMenu: [],
                        needUpgrade: [],
                    },
                    ...(CONTACTS_ENABLED ? [
                        {
                            key: 'contacts',
                            path: '/hub/contacts',
                            title: 'Contacts',
                            translateKey: 'nav.contacts',
                            icon: 'contacts',
                            type: NAV_ITEM_TYPE_ITEM,
                            authority: [],
                            subMenu: [],
                            needUpgrade: [],
                        },
                    ] : []),
                ],
            },
            {
                key: 'autopilot',
                path: '/autopilot/rules',
                title: 'Autopilot',
                translateKey: 'nav.autopilot',
                icon: 'autopilot',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [
                    // {
                    //     key: 'rules',
                    //     path: '/autopilot/rules',
                    //     title: 'Auto-Listing',
                    //     translateKey: 'nav.autolisting',
                    //     icon: 'autolist',
                    //     type: NAV_ITEM_TYPE_ITEM,
                    //     authority: [],
                    //     subMenu: [],
                    // },
                    // {
                    //     key: 'autocreate',
                    //     path: '/autopilot/posts',
                    //     title: 'Auto-Creation',
                    //     translateKey: 'nav.autocreate',
                    //     icon: 'autocreate',
                    //     type: NAV_ITEM_TYPE_ITEM,
                    //     authority: [],
                    //     subMenu: [],
                    //     disabled: true
                    // }
                ],
            },
        ],
    },

    // Analytics & Insights Section
    {
        key: 'analytics.section',
        path: '',
        title: 'Analytics & Insights',
        translateKey: 'nav.analyticsInsights',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'analytics',
                path: '/analytics',
                title: 'Analytics',
                translateKey: 'nav.analytics',
                icon: 'analytics',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            // ...(!isWhitelabel ? [
            //     {
            //         key: 'community',
            //         path: '/community/feed',
            //         title: 'Community Feed',
            //         translateKey: 'nav.community_feed',
            //         icon: 'community_feed',
            //         type: NAV_ITEM_TYPE_ITEM,
            //         authority: [],
            //         subMenu: [],
            //     },
            // ] : []),
        ],
    },

    // Settings & Configuration Section
    {
        key: 'settings.section',
        path: '',
        title: 'Settings & Configuration',
        translateKey: 'nav.settingsConfiguration',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'subscription',
                path: '/subscription',
                title: 'Subscription',
                translateKey: 'nav.subscription',
                icon: 'subscription',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['owner'],
                subMenu: [],
            },
            {
                key: 'company-settings',
                path: '/company-settings/profile',
                title: 'Company Settings',
                translateKey: 'nav.companySettings',
                icon: 'settings',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['owner'],
                subMenu: [],
            },
            {
                key: 'integrations',
                path: '/integrations',
                title: 'Integrations',
                translateKey: 'nav.integrations',
                icon: 'integrations',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            // Conditionally include the appropriate whitelabel navigation item
            ...(hasWhiteLabelAddOn ? [
                {
                    key: 'whitelabel',
                            path: '',
                    title: 'Whitelabel',
                    translateKey: 'nav.whitelabel',
                    icon: 'whitelabel',
                    type: NAV_ITEM_TYPE_COLLAPSE,
                    authority: ['owner'],
                    subMenu: [
                        {
                            key: 'whitelabel-management',
                            path: '/whitelabels/management',
                            title: 'Management',
                            translateKey: 'nav.management',
                            icon: 'management',
                            type: NAV_ITEM_TYPE_ITEM,
                            authority: [],
                            subMenu: [],
                        },
                        {
                            key: 'whitelabel-settings',
                            path: '/whitelabels/settings',
                            title: 'Settings',
                            translateKey: 'nav.settings',
                            icon: 'settings',
                            type: NAV_ITEM_TYPE_ITEM,
                            authority: [],
                            subMenu: [],
                        },
                    ],
                }
            ] : [
                {
                    key: 'whitelabel',
                    path: '/whitelabel',
                    title: 'Whitelabel',
                    translateKey: 'nav.whitelabel',
                    icon: 'whitelabel',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: ['owner'],
                    subMenu: [],
                }
            ]),
        ],
    },

    // Admin Section
    ...(isSystemAdmin ? [
        {
            key: 'admin.section',
            path: '',
            title: 'Admin',
            translateKey: 'nav.adminSection',
            icon: '',
            type: NAV_ITEM_TYPE_TITLE,
            authority: ['sysadmin'],
            subMenu: [
                {
                    key: 'admin-dashboard',
                    path: '/admin',
                    title: 'Admin Dashboard',
                    translateKey: 'nav.adminDashboard',
                    icon: 'admin',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
                {
                    key: 'admin-users',
                    path: '/admin/users',
                    title: 'Users',
                    translateKey: 'nav.adminUsers',
                    icon: 'admin_users',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
                {
                    key: 'admin-impersonate',
                    path: '/admin/users/impersonate',
                    title: 'Impersonate Users',
                    translateKey: 'nav.adminImpersonate',
                    icon: 'admin_impersonate',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
                {
                    key: 'admin-banners',
                    path: '/admin/banners',
                    title: 'Banner News',
                    translateKey: 'nav.adminBanners',
                    icon: 'admin_banners',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
            ],
        },
    ] : []),
];


const createAIStudioNavigationConfig = (hasWhiteLabelAddOn = false, isWhitelabel = false, isSumoling = false, isSystemAdmin = false) => [
    // Dashboard Section
    {
        key: 'dashboard.section',
        path: '',
        title: 'Dashboard',
        translateKey: 'nav.dashboard',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'home',
                path: '/home',
                title: 'Home',
                translateKey: 'nav.home',
                icon: 'home',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
        ],
    },

    // AI Images Section
    {
        key: 'ai_images.section',
        path: '',
        title: 'AI Images',
        translateKey: 'nav.ai_images_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            ...(AI_CREATIVE_STUDIO_ENABLED ? [{
                key: 'ai-creative-studio',
                path: '/ai-creative-studio',
                title: 'Creative Studio',
                translateKey: 'nav.creative_studio',
                icon: 'creative_studio',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                new: true,
            }] : []),
            {
                key: 'ai-image',
                path: '/ai-image',
                title: 'AI Images',
                translateKey: 'nav.ai_images',
                icon: 'ai_images',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'ai-image-create',
                path: '/ai-image-create',
                title: 'Create AI Image',
                translateKey: 'nav.create_ai_image',
                icon: 'ai_images',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            ...(!isSumoling ? [
                {
                    key: 'ai-image-editor',
                    path: '/ai-image-editor',
                    title: 'AI Image Editor',
                    translateKey: 'nav.ai_image_editor',
                    icon: 'ai_image_editor',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                }
            ] : []),
        ],
    },

    // AI Videos Section
    {
        key: 'ai_videos.section',
        path: '',
        title: 'AI Videos',
        translateKey: 'nav.ai_videos_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'ai-videos',
                path: '/ai-videos',
                title: 'AI Videos',
                translateKey: 'nav.ai_videos',
                icon: 'video',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'ai-videos-create',
                path: '/ai-videos-create',
                title: 'Create AI Video',
                translateKey: 'nav.create_ai_video',
                icon: 'video',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
        ],
    },

    // AI Avatars Section
    ...(AI_AVATARS_ENABLED ? [{
        key: 'ai_avatars.section',
        path: '',
        title: 'AI Avatars',
        translateKey: 'nav.ai_avatars_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'ai-avatars',
                path: '/ai-avatars',
                title: 'My AI Avatars',
                translateKey: 'nav.ai_avatars',
                icon: 'avatar',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
            {
                key: 'ai-avatars-create',
                path: '/ai-avatars-create',
                title: 'Create Avatar Video',
                translateKey: 'nav.ai_avatars_creator',
                icon: 'avatar_creator',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
            {
                key: 'ai-avatar-images',
                path: '/ai-avatar-images',
                title: 'Create Avatar Images',
                translateKey: 'nav.ai_avatar_images',
                icon: 'ai_avatar_images',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
        ],
    }] : []),

    // AI Viral Shorts Section
    ...(AI_AVATARS_ENABLED ? [{
        key: 'viral_shorts.section',
        path: '',
        title: 'AI Viral Shorts',
        translateKey: 'nav.viral_shorts_section',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'viral-shorts',
                path: '/viral-shorts',
                title: 'AI Viral Shorts',
                translateKey: 'nav.viral_shorts',
                icon: 'viral_shorts',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
            {
                key: 'viral-short-creator',
                path: '/viral-short-creator',
                title: 'Viral Short Creator',
                translateKey: 'nav.viral_short_creator',
                icon: 'video',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                needUpgrade: AI_STUDIO_BLOCKED_PLANS,
            },
        ],
    }] : []),

    // Content & Scheduling Section
    {
        key: 'content.section',
        path: '',
        title: 'Content & Scheduling',
        translateKey: 'nav.contentScheduling',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'calendar',
                path: '/calendar',
                title: 'Calendar',
                translateKey: 'nav.calendar',
                icon: 'calendar',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'posts',
                path: '/posts',
                title: 'My Posts',
                translateKey: 'nav.posts',
                icon: 'posts',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'media',
                path: '/media',
                title: 'Media Library',
                translateKey: 'nav.my_media',
                icon: 'my_media',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
        ],
    },

    // Settings & Configuration Section
    {
        key: 'settings.section',
        path: '',
        title: 'Settings & Configuration',
        translateKey: 'nav.settingsConfiguration',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'subscription',
                path: '/subscription',
                title: 'Subscription',
                translateKey: 'nav.subscription',
                icon: 'subscription',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['owner'],
                subMenu: [],
            },
            {
                key: 'company-settings',
                path: '/company-settings/profile',
                title: 'Company Settings',
                translateKey: 'nav.companySettings',
                icon: 'settings',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['owner'],
                subMenu: [],
            },
            {
                key: 'integrations',
                path: '/integrations',
                title: 'Integrations',
                translateKey: 'nav.integrations',
                icon: 'integrations',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            // Conditionally include the appropriate whitelabel navigation item
            ...(hasWhiteLabelAddOn ? [
                {
                    key: 'whitelabel',
                    path: '',
                    title: 'Whitelabel',
                    translateKey: 'nav.whitelabel',
                    icon: 'whitelabel',
                    type: NAV_ITEM_TYPE_COLLAPSE,
                    authority: ['owner'],
                    subMenu: [
                        {
                            key: 'whitelabel-management',
                            path: '/whitelabels/management',
                            title: 'Management',
                            translateKey: 'nav.management',
                            icon: 'management',
                            type: NAV_ITEM_TYPE_ITEM,
                            authority: [],
                            subMenu: [],
                        },
                        {
                            key: 'whitelabel-settings',
                            path: '/whitelabels/settings',
                            title: 'Settings',
                            translateKey: 'nav.settings',
                            icon: 'settings',
                            type: NAV_ITEM_TYPE_ITEM,
                            authority: [],
                            subMenu: [],
                        },
                    ],
                }
            ] : []),
        ],
    },

    // Admin Section
    ...(isSystemAdmin ? [
        {
            key: 'admin.section',
            path: '',
            title: 'Admin',
            translateKey: 'nav.adminSection',
            icon: '',
            type: NAV_ITEM_TYPE_TITLE,
            authority: ['sysadmin'],
            subMenu: [
                {
                    key: 'admin-dashboard',
                    path: '/admin',
                    title: 'Admin Dashboard',
                    translateKey: 'nav.adminDashboard',
                    icon: 'admin',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
                {
                    key: 'admin-users',
                    path: '/admin/users',
                    title: 'Users',
                    translateKey: 'nav.adminUsers',
                    icon: 'admin_users',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
                {
                    key: 'admin-impersonate',
                    path: '/admin/users/impersonate',
                    title: 'Impersonate Users',
                    translateKey: 'nav.adminImpersonate',
                    icon: 'admin_impersonate',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
                {
                    key: 'admin-banners',
                    path: '/admin/banners',
                    title: 'Banner News',
                    translateKey: 'nav.adminBanners',
                    icon: 'admin_banners',
                    type: NAV_ITEM_TYPE_ITEM,
                    authority: [],
                    subMenu: [],
                },
            ],
        },
    ] : []),
];

// Create a context for the navigation configuration
const NavigationContext = createContext({
    navigationConfig: createNavigationConfig(false),
    fullNavigationConfig: createNavigationConfig(false),
    updateNavigation: () => {}
})

// Create a hook to use the navigation context
export const useNavigation = () => useContext(NavigationContext)

// Export the navigation config with default value (non-whitelabel)
const navigationConfig = createNavigationConfig()

export default navigationConfig

// Export the provider component for the navigation context
export const NavigationProvider = ({ children }) => {
    const { isSumoling, isLicensee } = useContext(AppSumoContext);
    const { company, mainUserPlanType, mainUser } = useContext(CompanyContext);
    const { isSystemAdmin } = useContext(CompanyContext);
    const { hasWhiteLabelAddOn, isWhitelabel } = useWhitelabel()
    const menuVisibility = company?.menu_visibility;

    const fullNavigationConfig = useMemo(() => {
        const effectiveSumoling = isSumoling() && !isLicensee();
        return createNavigationConfig(hasWhiteLabelAddOn, isWhitelabel, effectiveSumoling, isSystemAdmin);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasWhiteLabelAddOn, isWhitelabel, isSumoling(), isLicensee(), mainUserPlanType, isSystemAdmin, mainUser?.id]);

    const navigationConfig = useMemo(
        () => filterNavigationByVisibility(fullNavigationConfig, menuVisibility),
        [fullNavigationConfig, menuVisibility]
    );

    return (
        <NavigationContext.Provider value={{ navigationConfig, fullNavigationConfig }}>
            {children}
        </NavigationContext.Provider>
    )
}
